// Base comum dos eixos plotly
export const axisBase = {
  visible: true,
  ticks: 'outside' as const,
  ticklen: 4,
  tickcolor: '#d1d5db',
  tickfont: { size: 12, color: '#000', family: 'Figtree, sans-serif' },
  showgrid: true,
  gridcolor: '#f1f5f9',
  gridwidth: 1,
  showline: true,
  linecolor: '#e5e7eb',
  linewidth: 1,
  zeroline: false,
  automargin: true,
}

export const buildXTicks = (totalPoints: number) => {
  const n = Math.max(1, totalPoints)

  if (n <= 1) return { vals: [1], texts: ['1'] }

  if (n <= 10) {
    const vals = Array.from({ length: n }, (_, i) => i + 1)
    return { vals, texts: vals.map(String) }
  }

  if (n <= 30) {
    const base = [1, 5, 10, 15, 20, 25, n]
    const vals = Array.from(new Set(base.filter(v => v <= n))).sort((a, b) => a - b)
    return { vals, texts: vals.map(String) }
  }

  // Series semanais
  if (n <= 60) {
    const vals = [1, 10, 20, 30, 40].filter(v => v < n)
    vals.push(n)
    return { vals, texts: vals.map(String) }
  }

  // Genérico para séries longas
  const candidates = [5, 10, 15, 20, 25, 30]
  const approx = (n - 1) / 6
  const step = candidates.reduce(
    (best, c) => (Math.abs(c - approx) < Math.abs(best - approx) ? c : best),
    candidates[0],
  )
  const vals = new Set<number>([1, n])
  for (let v = step; v < n; v += step) vals.add(Math.round(v))
  const sorted = Array.from(vals).sort((a, b) => a - b)
  return { vals: sorted, texts: sorted.map(String) }
}

export const buildDayOfMonthTicks = (totalDaysPlotted: number) => {
  const n = Math.max(1, totalDaysPlotted)

  if (n <= 12) {
    const vals = Array.from({ length: n }, (_, i) => i + 1)
    return { vals, texts: vals.map(String) }
  }

  const base = [1, 5, 10, 15, 20, 25]
  const vals = base.filter(v => v <= n)
  if (!vals.includes(n)) vals.push(n) // garante 29/30/31
  return { vals, texts: vals.map(String) }
}

// Ticks para dia do ano (plotly anual)
export const buildDayOfYearTicks = (totalDays: number, opts?: { minGap?: number }) => {
  const n = Math.max(1, totalDays)
  const minGap = Math.max(1, opts?.minGap ?? 25)

  const candidates = [1, 50, 100, 150, 200, 250, 300, 350]

  const values = candidates.filter(value => value <= n - minGap)

  if (!values.includes(n)) values.push(n)

  return { vals: values, texts: values.map(String) }
}

// export const buildDayTicks = buildDayOfMonthTicks
